module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.20.0.0.box.206.450.1293.240.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.20.0.0.box.654.450.400.39.q.80"
    }
  }, [_vm._v("CHAPTER ONE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.20.0.1.box.206.595.1293.95.q.90"
    }
  }, [_vm._v("A Beautiful New Decade")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.1.0.box.100.1340.1515.1670.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.1.0.box.100.1340.1510.426.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.0.0"
    }
  }), _vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Orleans ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("rolled ")]), _vm._v("into the forties as smoothly as a night train crossing a state border. Nothing changed but the calendar. Robert Maestri had been mayor for four years and would continue in office for another six. Franklin D. Roosevelt had been president for eight years, and there was talk that he might run again for an unprecedented third term. Even the Catholic church, a strong force in the city, had been under the leadership of Archbishop Joseph Francis Rummel since 1935, and would continue to be for many years to come. Nothing moved swiftly in the Crescent City.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.1.box.105.1776.1506.263.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.1.0"
    }
  }), _vm._v("When the bells rang at midnight on January 1, 1940, the Great Depression had not yet ended, but unemployment had been reduced by Roosevelt's PWA and WPA. Prohibition had been repealed, and gangland murder had become little more than a memory. Things were better for most Americans but they were far from perfect.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.2.box.107.2050.1505.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.2.0"
    }
  }), _vm._v("We knew, of course, that the German Nazi dictator Adolf Hitler had sent his goose-stepping troops into Poland the previous September, engaging in the first real bloodshed of the European conflict, but New Orleanians were not too concerned about the foreign war. We tried not to think about it. Like Americans everywhere, we called ourselves Isolationists, or America Firsters.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.3.box.109.2319.1504.307.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.3.0"
    }
  }), _vm._v("On January first of the New Year, Tulane fans were a lot more concerned about whether \"Jarrin\"' John Kimbrough of Texas A & M would jar the Tulane Green Wave out of a victory in the Sugar Bowl game. Their money was on the Greenies' 160-pound scatback, Bobby (\"Jitterbug\") Kellogg, who they hoped could save the day. The game had been touted as a \"David and Goliath\" match, with A & M in the role of Goliath.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.4.box.113.2644.1501.144.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.4.0"
    }
  }), _vm._v("Hotel owners and restaurateurs scowled over their cash registers, wishing the Mid-Winter Sports Association had invited two out-of-town teams, which would have doubled their tourist dollars.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.5.box.114.2806.1501.204.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.5.0"
    }
  }), _vm._v("In homes all over the city, children slept late and then enjoyed the holiday, reading their favorite comic strips: "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("L'il ")]), _vm._v("Abner, Boots 'n "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Her ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Buddies, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Toots ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("'n ")]), _vm._v("Casper, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Scorchy ")]), _vm._v("Smith. Adults read the section in the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Times-Picayune ")]), _vm._v("where the columnist Lucie Neville predicted that the best bets for stardom in the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.1.0.box.825.347.1506.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  }), _vm._v("\ncoming year were Mary Martin, Betty Field, William Holden, Robert Cummings, Linda Darnell, Lana Turner, and luscious Brenda Marshall, slated to star opposite Errol Flynn in "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sea ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hawk. ")])])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.21.1.0.box.825.347.1512.1291.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.1.box.826.508.1507.478.q.60"
    }
  }, [_vm._v("At noon, families gathered around the dinner table to enjoy the traditional New Orleans meal, which included cabbage (for money in the New Year) and black-eyed peas (for luck). Some dined out at the new St. Regis Restaurant on Airline Highway or at Lenfant's on Canal Boulevard, and then danced to the music of the jukebox playing \"I'll Never Smile Again\" or \"Apple Blossom Time.\" After the midday meal, those who were not sports fans were queuing up at the neighborhood theaters to see "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Charlie ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chan ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Panama ")]), _vm._v("with Sidney Toler, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Want ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Divorce ")]), _vm._v("with Dick Powell and Joan Blondell, or "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Strike ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Up ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Band ")]), _vm._v("with Mickey Rooney and Judy Garland.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.2.box.828.995.1503.211.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.2.0"
    }
  }), _vm._v("There was a lot to do in New Orleans for those who had the money. At the Municipal Auditorium, Alfred Lunt and Lynn Fontaine were playing in "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Taming ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Shrew. ")]), _vm._v("And at the Fair Grounds Race Track, post time was 2:15 "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("P.m. ")]), _vm._v("and general admission was forty cents.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.3.box.829.1216.1508.422.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.3.0"
    }
  }), _vm._v("Few were thinking about American involvement in the war. They felt secure in the knowledge that the United States had signed a series of Neutrality Acts, that President Roosevelt had promised that our boys would not be sent into battle, and that men like Senator William E. Borah were calling the trouble in Europe a \"phony war.\" To a young teenager like me, 1940 gave every promise of excitement, with new hairdos and fashions, music and dancing, and hopefully, boys and dating. As a junior in high school, I was not yet dating, but I was working on it. War, I must confess, was the farthest thing from my mind.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.21.2.0.box.829.1741.1505.306.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.21.2.0.box.830.1741.696.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.0.0"
    }
  }), _vm._v("COLDEST MONTH ON RECORD")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.2.1.box.829.1844.1505.203.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.0.0"
    }
  }), _vm._v("On January 3, tarpaulins covered plants and flowers all over the city in preparation for the season's first subfreezing weather. A temperature of thirty degrees was predicted. In the next thirty days, the city would endure its coldest weather in the history of the weather bureau.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.3.0.box.833.2153.1510.843.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.21.3.0.box.833.2153.443.34.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.4.0.0"
    }
  }), _vm._v("AN ORDINARY DAY")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.3.1.box.834.2251.1509.370.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.5.0.0"
    }
  }), _vm._v("On an ordinary schoolday, my friend Audrey and I rode the St. Claude streetcar to Holy Angels Academy in the Ninth Ward, dressed in our convent uniforms of white sport shirts, navy blue pleated skirts, saddle oxfords, and bobby sox. In a crowded streetcar, we got to sneak a peek at a few good-looking boys from Holy Cross High School who rode the same car to their campus a mile past our own, and to smile at them if we were bold enough. This brought on fits of giggling and book-dropping, but it was an exhilarating way to begin a day.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.3.2.box.835.2629.1506.367.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.5.1.0"
    }
  }), _vm._v("Oh, what rollicking, frolicking trolleys t"), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.6.0.0"
    }
  }), _vm._v("hose St. Claude streetcars were! Flirting "), _c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _vm._v("carried us to and from our destinations, pumping us full of adrenalin for the day, and indeed preparing u"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _vm._v("s for the glorious boy-girl connections we"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.0.0"
    }
  }), _vm._v(" so coveted. It was all innocent enough, of course. Sophomores "), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.0.0"
    }
  }), _vm._v("dared not even talk to boys. Juniors timid"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.4.0.0"
    }
  }), _vm._v("ly answered their questions. But something miraculous happened "), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.5.0.0"
    }
  }), _vm._v("to girls in the summer before their senior"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.6.0.0"
    }
  }), _vm._v(" year of high school. Suddenly, they found it easier to carry o"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.7.0.0"
    }
  }), _vm._v("n mile-long conversations with Holy Cross boys, sometimes"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.7.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.23.1.0.box.823.325.1506.94.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _vm._v("\neven football players, talks which often resulted in invitations to Holy Cross dances or boatrides on the steamer "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("President. ")])])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.22.0.0.box.126.25.2060.3228.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0015.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.1.0.box.823.325.1516.2695.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.1.box.824.434.1506.318.q.60"
    }
  }, [_vm._v("Besides the daily classes and brown-bag lunches on the tree-shaded campus, our school offered choral singing, which Audrey and I adored. My favorite afterschool activity was writing for the Marianite newspaper. On rainy days at lunchtime, we all gathered in the upstairs auditorium, moved the chairs to one side, and paired off to dance the jitterbug while Dora Arroya played all the fast songs like \"Hold Tight\" and \"Boogie Woogie Bugle Boy\" on the piano.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.2.box.826.761.1511.416.q.60"
    }
  }, [_vm._v("After school each day, Audrey and I rode the streetcar to Canal Street, where we were supposed to transfer to the Cemeteries streetcar for the second half of our journey home. Instead, we spent an hour each day perusing the wares of the gigantic new Woolworth Five-and-Dime on Canal and Rampart. It was "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("our ")]), _vm._v("store, built the first year we were in high school. There, we could look at Tangee lipsticks, compacts of Coty's powder, and tiny bottles of Blue Waltz perfume at ten cents a bottle—the treasures of the Orient to us. The shining tiled floors of the aisles beckoned us. We loved Woolworth's.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.3.box.828.1194.1509.532.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.3.0"
    }
  }), _vm._v("Every afternoon found us at the soda fountain there, wolfing down slices of chocolate cake with vanilla ice cream (ten cents) and regaling the waitresses with tall tales. We told them we were twins, not identical but fraternal (we did not resemble each other at all). We said we had been born in France and spoke French fluently, and then, having ascertained that they knew no French, rattled off the Our Father and Hail Mary in French, in small conversational segments, as if we were talking to each other or asking them questions. We knew the prayers by heart from our French class. The waitresses seemed mesmerized by us. We thought they were impressed. I now believe they thought us demented and were trying to be kind.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.4.box.831.1735.1505.207.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.4.0"
    }
  }), _vm._v("One day, we stayed at Woolworth's too long and the time on our streetcar transfers expired. We tried to bluff our way in, but the conductor put us off the car. So there we were on Canal Street without a penny in our purses, and"), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.0.0"
    }
  }), _vm._v(" no way to get home.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.5.box.832.1951.1505.90.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.0.0"
    }
  }), _vm._v("\"Let's go to Paw's office,\" I suggested. \"It's just a block away. He'll lend us carfare.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.6.box.834.2058.1502.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.1.0"
    }
  }), _vm._v("We trudged to the Audubon Building and the office of my grandfather. He was a German watchmaker of wide renown, I was later to discover. But to me he was Paw, the little old man who lived upstairs in my father's duplex, who wore bow ties and smoked cigars and put wine in his soup.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.7.box.834.2276.1503.151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.2.0"
    }
  }), _vm._v("We explained our predicament. He smiled behind his gray soupstrainer moustache and drew a little coin purse from his trouser pocket. With his long fingernails, he picked out a quarter.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.8.box.835.2437.1502.98.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.3.0"
    }
  }), _vm._v("\"Two bits enough?\" he asked, obviously pleased as punch that we had come to him. Paw always counted money in \"bits.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.9.box.881.2545.995.43.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.4.0"
    }
  }), _vm._v("\"That'll be swell,\" I answered. \"We'll pay you back.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.10.box.835.2598.1503.154.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.5.0"
    }
  }), _vm._v("Carfare was seven cents each, I calculated. That would leave us eleven cents for jelly beans to eat on the way home. After leaving his office, we made a beeline to Kress, next door to the Audubon Building, and bought our jelly beans.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.11.box.836.2762.1503.258.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.6.0"
    }
  }), _vm._v("Of course, we never paid him back. And what was worse, we were now convinced that it made the old man so happy to lend us the money that we never bothered to check the time on our transfers after that. We lingered at Woolworth's, trying on the jewelry and bandanas and crocheted gloves to our hearts' content, and if we were late on our transfers, we just paid Paw a visit.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.0.0.box.100.356.1514.836.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.24.0.0.box.100.356.739.38.q.70"
    }
  }, [_vm._v("LIFE WAS GOOD TO TEENAGERS")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.0.1.box.100.439.1513.374.q.60"
    }
  }, [_vm._v("Life was good to us in the early months of 1940. We had only an occasional date to a downtown movie by way of the streetcar, but we slept over at each other's houses, and amused ourselves trying out the new pageboy hairdos and looking through magazines, admiring the strapless evening dresses. We longed for the day when we'd fill out enough to have something to hold them up. We went on occasional chaperoned truckrides to Packenham Oaks in Chalmette, and to all-day school dances on the steamer President.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.0.2.box.104.824.1510.368.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.1.0"
    }
  }), _vm._v("Val Barbara's Band played for the high school boatrides on the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("President, ")]), _vm._v("and we adored his renditions of Glenn Mill"), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.0.0"
    }
  }), _vm._v("er's latest hits. I remember the huge, magnificent ladies' dressing rooms on the boat, done in art deco with a prepondera"), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.4.0.0"
    }
  }), _vm._v("nce of blue mirrors, which were all the rage. Our mothers sometimes came, carrying a big picnic lunch. They watched from the u"), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.6.0.0"
    }
  }), _vm._v("pstairs balcony as we jitterbugged the day away. Those were good days, and no thoughts of war intruded to diminish their glory.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.24.1.0.box.2.1227.2435.2045.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0016.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.1.0.box.825.345.1513.2458.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.25.1.0.box.825.345.414.35.q.80"
    }
  }, [_vm._v("CURRENT EVENTS")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.1.box.827.428.1504.207.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.0.0"
    }
  }), _vm._v("Then one day in September, we were assigned a debate in history class. The motion on the positive was that Franklin D. Roosevelt should run for a third term; on the negative: he should not. Audrey was on the team for the positive. I was on the negative. We asked my father to help us.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.2.box.828.646.1505.256.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.1.0"
    }
  }), _vm._v("By 1940, Daddy had changed his voter registration. Now he was a Republican. (In 1932, he had voted for Roosevelt.) He could give me a dozen reasons why Roosevelt should not run. But Audrey wanted his help, too. So Daddy, who was a walking encyclopedia of current events, reluctantly came up with a few points in favor of a third term.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.3.box.829.919.1507.370.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.2.0"
    }
  }), _vm._v("We spent a whole Sunday afternoon in the living room with my father, talking Roosevelt and Isolationism, and discussing the possibility of getting into the war sooner or later. It frightened me when my father explained that although Roosevelt had promised again and again that our boys would not be sent into any foreign wars, he had asked Congress in his State of the Union message in January for funds to finance the biggest peacetime military buildup in the history of our country.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.4.box.831.1298.1505.480.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.3.0"
    }
  }), _vm._v("Inspired by a captive audience, my father told us that as far back as 1938, Hitler had demanded the annexation of Czechoslovakia's Sudetenland, a land rich in mines, industry, and fortifications. British Prime Minister Chamberlain had made three visits to Germany, always trying to appease the dictator. Britain and France had no heart for battle. It had been only twenty years since they had lost millions of men in what was still called the Great War. Finally, Chamberlain and French Premier Deladier gave in to Hitler's demands at Munich and, in September 1938, Czechoslovakia lost the Sudetenland to Germany. Chamberlain returned to England saying that the pact meant \"peace for our time.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.5.box.833.1788.1504.142.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.4.0"
    }
  }), _vm._v("My father felt strongly that if France and England had acted five or six years earlier, Hitler would not have been a threat in 1940, and America's help might not be needed in the future.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.6.box.834.1948.1504.365.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.5.0"
    }
  }), _vm._v("Later in 1938, he said, France and England had pledged their support to Poland. By then, France had built the Maginot Line to defend against Hitler's assault, and assembled the greatest army in Europe, or so they thought. Then in September 1939, a German army of a million men, with tank divisions and the most powerful air force in Europe, invaded Poland at dawn. Before noon, Poland had become the first European country to experience the blitzkrieg (lightning war).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.7.box.835.2326.1503.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.6.0"
    }
  }), _vm._v("In fifteen days, the Nazis had conquered western Poland. Russia took this opportunity to cross Poland's Eastern Frontier, and Poland collapsed under the force of the two invading armies. Germany and Russia then signed an agreement of friendship, and divided Poland between them.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.8.box.882.2542.1065.44.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.7.0"
    }
  }), _vm._v("\"Where were England and France all this time?\" I asked.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.9.box.837.2597.1501.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.8.0"
    }
  }), _vm._v("\"They declared war against Germany two days after the invasion of Poland,\" my father said, \"but since they were unable to help at the Eastern Front, they hoped that this would draw German troops to the Western front. But the Nazis conquered Poland anyway.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.0.0.box.114.356.1514.1293.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.0.box.114.356.1510.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _vm._v("\"Last April, the Nazis took Denmark in just a few hours. They took Norway in just a few days. And then they marched through France, victorious. You saw it on the newsreel, the French people crying, the troops marching down the Champs Elysees.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.1.box.118.574.1506.99.q.50"
    }
  }, [_vm._v("\"But what happened to the Maginot Line?\" I asked, caught up in the incredible tale of conquest.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.2.box.117.682.1504.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.2.0"
    }
  }), _vm._v("\"It didn't stop Hitler. The French and the English armies joined to fight him, but in two weeks, they were retreating toward the beaches of Dunkirk.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.3.box.118.790.1508.199.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.3.0"
    }
  }), _vm._v("I remembered then a Sunday afternoon when Audrey and I had sat in the flickering light of the Carrollton Theater, watching a newsreel that showed the courageous evacuation of Dunkirk in British rescue ships, including fishing boats and motor boats.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.4.box.120.1008.1506.144.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.4.0"
    }
  }), _vm._v("\"It was just last June that the Nazis occupied Paris,\" my father said. \"An armistice was signed between France and Germany. The rest of the French army was demobilized.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.5.box.120.1171.1507.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.5.0"
    }
  }), _vm._v("\"Hitler hates the Jews,\" my father said, moving on to another aspect of the Nazi menace. \"He's making life unbearable for them. His storm troopers have destroyed their places of business. They have no work, no place to live, no citizenship. Many have already refugeed to France and England for protection.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.6.box.167.1388.1391.45.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.6.0"
    }
  }), _vm._v("We listened, caring suddenly, chiding ourselves for our past frivolousness.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.7.box.121.1443.1507.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.7.0"
    }
  }), _vm._v("The school debate was held, and the juniors of Holy Angels Academy voted that Roosevelt should have no third term. Somehow he was still elected in November, defeating Wendell Willkie, a last-minute choice of the Republicans. For the first time in our history, a president would serve more than eight years.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.26.2.0.box.1758.1186.384.410.q.20"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.9.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0017.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.9.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.3.0.box.123.1732.1510.1145.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.26.3.0.box.125.1732.514.36.q.80"
    }
  }, [_vm._v("KNITTIN' FOR BRITAIN")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.3.1.box.123.1808.1508.421.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.10.0.0"
    }
  }), _vm._v("Close on the heels of our debate came another event that raised our consciousness level one more notch. A British lady spoke to the student body about the Battle of Britain. She told us of bombs that had been falling on London since July. She described suburbs covered by rubble, where lovely homes and gardens had been demolished. She spoke of air-raid sirens and people running for hastily dug shelters or subways, of children crying and the sky exploding with light as anti-aircraft weapons fought the German "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Luftwaffe ")]), _vm._v("(air force) to prevent destruction of the city.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.3.2.box.128.2239.1504.265.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.10.1.0"
    }
  }), _vm._v("Many English people were homeless and without food or clothing, she said, and she had come to visit schools all over America to ask for canned goods and used clothing. More than that, she had come to teach us to knit, of all things. Audrey and I looked at each other and shrugged. Although we and our friends would normally have giggled at the idea, no one did. We were deeply moved.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.3.3.box.130.2513.1503.364.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.10.2.0"
    }
  }), _vm._v("She wanted us to learn to knit warm socks, gloves, and scarves for the homeless who were about to endure a bitter winter without shelter. Our hearts went out to our British cousins, and we sat in quiet little groups as she came around with knitting needles and yarn, giving lessons in knitting and purling to eager young fingers. Before long we were spending our lunch hours \"knittin' for Britain,\" proudly comparing our socks and gloves, which the nuns were to mail on for us. We were becoming involved in the war effort.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.27.1.0.box.824.339.1506.1868.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.27.1.0.box.824.339.626.36.q.80"
    }
  }, [_vm._v("OTHER TEENAGE PURSUITS")]), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.1.box.826.423.1499.535.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.0.0"
    }
  }), _vm._v("I began reading the newspapers a bit more carefully and discovered that, while in 1939 the United States had stopped all shipments of American arms to warring nations, later on it allowed the Allies to buy goods on a \"cash and carry\" basis. England, however, had no more funds and China, in a life-and-death struggle with Japan, was also out of money. In September 1940, the United States gave Britain fifty overage destroyers in exchange for the right to lease military bases in Bermuda, Newfoundland, and the British West Indies. Roosevelt considered it the best land deal since the Louisiana Purchase. He asked the United States to become the \"great arsenal of democracy,\" and to supply war materials to the Allies through sale, loan, or lease.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.2.box.828.968.1499.264.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.1.0"
    }
  }), _vm._v("This was heavy reading for a junior in high school. To me, it was like algebra—hard to understand and boring, but something I would not be allowed to get by without knowing. But 1941 was coming, and in the spring, we'd be going to our Junior-Senior Prom. My heart leapt at the very thought of it, and the dismal prospect of an ever-approaching war was forgotten.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.3.box.829.1241.1501.198.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.2.0"
    }
  }), _vm._v("Who would I ask to be my date? I had no special boyfriend as yet. What kind of dress would I have Mrs. Scott, my neighborhood seamstress, make for me? I began sketching long-waisted, full-skirted dresses in the back of my history notebook.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.4.box.830.1458.1497.200.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.3.0"
    }
  }), _vm._v("As 1940 ended, Mother read aloud to me from Dorothy Kilgallen's column about the popular novel "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Kitty ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Foyle. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Kitty ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Foyle, ")]), _vm._v("by Christopher Motley,\" she read, \"is the most daring novel ever written by a man about a woman. No woman would ever admit what it reveals.'\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.5.box.831.1676.1497.314.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.4.0"
    }
  }), _vm._v("She looked up and we locked eyes. She had my attention. And since the novel was serialized in the daily paper, I wasted no time sneaking it to my room and reading it. Although the love scenes were not the explicit sex scenes of today, and I was never quite sure what Kitty and her lover were doing, I got the picture when she turned up pregnant and unmarried. It was the first illicit love affair I had ever read, and I cried my eyes out and enjoyed it thoroughly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.6.box.832.2000.1496.207.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.5.0"
    }
  }), _vm._v("Another column in the newspaper which my mother read daily was \"Contract Bridge: How to Play and How to Win,\" by Josephine Culbertson. Until Culbertson arrived on the scene, we had all played auction bridge in my family. We were all avid cardplayers, and mother was now teaching us contract.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.2.0.box.834.2279.1500.717.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.27.2.0.box.834.2279.554.88.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.3.0.0"
    }
  }), _vm._v("DECEMBER BROUGHT CHRISTMAS AND TAXES")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.2.1.box.835.2413.1499.423.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.0.0"
    }
  }), _vm._v("In December 1940, the newspapers said that income taxes would go up to support the defense budget. It was to be called the Victory Tax, but in spite of that, it agitated both Republicans and Isolationists. Another distressing bit of news was that the 1 percent sales tax, which was to expire at the end of the year, would be replaced by a 2 percent sales tax, to be collected in brackets. There would be no tax up to 13 cents; one cent tax for purchases of 13 cents to 62 cents; two cents tax for purchases of 63 to 99 cents. It was the subject of conversation everywhere. How could middle-class people afford such high taxes?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.2.2.box.837.2845.1495.151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.1.0"
    }
  }), _vm._v("Christmas music and decorations in the stores took everyone's mind off war and taxes. Audrey and I fairly jigged down the aisles of Woolworth's to the tune of \"Deck the Halls\" as we searched the counters for gifts. We had been saving our"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.28.0.0.box.100.374.1508.89.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  }), _vm._v("\nnickels and quarters, and we each had enough money for small gifts for the members of our immediate families.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.0.0.box.100.374.1512.752.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.0.1.box.100.482.1511.308.q.50"
    }
  }, [_vm._v("I bought my mother a brown leather purse, all gift-wrapped in a see-through box for 50 cents. My daddy and my Memere got handkerchiefs (25 cents each). For my older brother, I bought a belt for 50 cents; for my younger sister, paper dolls at 25 cents; and for my younger brother, a football, 39 cents. I completed my Christmas shopping all in one day, and it had cost me less than $2.25, tax included.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.0.2.box.104.809.1508.317.q.60"
    }
  }, [_vm._v("For 1940, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Rebecca ")]), _vm._v("was picked as the best movie. Other movies mentioned were "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Edison ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.0.0"
    }
  }), _vm._v("Man, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Philadelphia ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Story, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Grapes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Wrath, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Our ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Town, ")]), _vm._v("and "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Abe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lincoln ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Illinois. ")]), _c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _vm._v("And as the year came to a close, the city once again welcomed its Sugar Bowl visitors. This time fans came from out of town to cheer for the Boston College and Tennesse"), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _vm._v("e teams. The Mid-Winter Sports Association had made the hotel owners and restaurateu"), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0"
    }
  }), _vm._v("rs very happy.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.29.0.0.box.43.169.2343.2745.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0018.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0.4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92f113ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0019.vue
// module id = 66
// module chunks = 0